export const TRANSLATION_SCOPE = 'layoutModule';
export const TRANSLATION_MENU_SCOPE = [TRANSLATION_SCOPE, 'menu'];
export const TRANSLATION_USER_MENU_SCOPE = [TRANSLATION_SCOPE, 'userMenu'];
export const TRANSLATION_LAYOUT_SCOPE = [TRANSLATION_SCOPE, 'layout'];
